/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  NewThemeSetting,
  RoleMappingCount200Response,
  RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest,
  RoleMappingExistsGetRoleMappingsIdExists200Response,
  RoleMappingUpdateAll200Response,
  ThemeSetting,
} from '../models/index';
import {
    NewThemeSettingFromJSON,
    NewThemeSettingToJSON,
    RoleMappingCount200ResponseFromJSON,
    RoleMappingCount200ResponseToJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestFromJSON,
    RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON,
    RoleMappingExistsGetRoleMappingsIdExists200ResponseToJSON,
    RoleMappingUpdateAll200ResponseFromJSON,
    RoleMappingUpdateAll200ResponseToJSON,
    ThemeSettingFromJSON,
    ThemeSettingToJSON,
} from '../models/index';

export interface ThemeSettingCountRequest {
    where?: string;
}

export interface ThemeSettingCreateRequest {
    data?: NewThemeSetting;
}

export interface ThemeSettingCreateChangeStreamGetThemeSettingsChangeStreamRequest {
    options?: string;
}

export interface ThemeSettingCreateChangeStreamPostThemeSettingsChangeStreamRequest {
    roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest?: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest;
}

export interface ThemeSettingDeleteByIdRequest {
    id: string;
}

export interface ThemeSettingExistsGetThemeSettingsidExistsRequest {
    id: string;
}

export interface ThemeSettingExistsHeadThemeSettingsidRequest {
    id: string;
}

export interface ThemeSettingFindRequest {
    filter?: string;
}

export interface ThemeSettingFindByIdRequest {
    id: string;
    filter?: string;
}

export interface ThemeSettingFindOneRequest {
    filter?: string;
}

export interface ThemeSettingPatchOrCreateRequest {
    data?: ThemeSetting;
}

export interface ThemeSettingPrototypePatchAttributesRequest {
    id: string;
    data?: ThemeSetting;
}

export interface ThemeSettingReplaceByIdPostThemeSettingsidReplaceRequest {
    id: string;
    data?: ThemeSetting;
}

export interface ThemeSettingReplaceByIdPutThemeSettingsidRequest {
    id: string;
    data?: ThemeSetting;
}

export interface ThemeSettingReplaceOrCreatePostThemeSettingsReplaceOrCreateRequest {
    data?: ThemeSetting;
}

export interface ThemeSettingReplaceOrCreatePutThemeSettingsRequest {
    data?: ThemeSetting;
}

export interface ThemeSettingUpdateAllRequest {
    where?: string;
    data?: ThemeSetting;
}

export interface ThemeSettingUpsertWithWhereRequest {
    where?: string;
    data?: ThemeSetting;
}

/**
 * 
 */
export class ThemeSettingApi extends runtime.BaseAPI {

    /**
     * Count instances of the model matched by where from the data source.
     */
    async themeSettingCountRaw(requestParameters: ThemeSettingCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingCount200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ThemeSettings/count`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Count instances of the model matched by where from the data source.
     */
    async themeSettingCount(requestParameters: ThemeSettingCountRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingCount200Response> {
        const response = await this.themeSettingCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async themeSettingCreateRaw(requestParameters: ThemeSettingCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ThemeSettings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Create a new instance of the model and persist it into the data source.
     */
    async themeSettingCreate(requestParameters: ThemeSettingCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.themeSettingCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async themeSettingCreateChangeStreamGetThemeSettingsChangeStreamRaw(requestParameters: ThemeSettingCreateChangeStreamGetThemeSettingsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters['options'] != null) {
            queryParameters['options'] = requestParameters['options'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ThemeSettings/change-stream`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async themeSettingCreateChangeStreamGetThemeSettingsChangeStream(requestParameters: ThemeSettingCreateChangeStreamGetThemeSettingsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.themeSettingCreateChangeStreamGetThemeSettingsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a change stream.
     */
    async themeSettingCreateChangeStreamPostThemeSettingsChangeStreamRaw(requestParameters: ThemeSettingCreateChangeStreamPostThemeSettingsChangeStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ThemeSettings/change-stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RoleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequestToJSON(requestParameters['roleMappingCreateChangeStreamPostRoleMappingsChangeStreamRequest']),
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Create a change stream.
     */
    async themeSettingCreateChangeStreamPostThemeSettingsChangeStream(requestParameters: ThemeSettingCreateChangeStreamPostThemeSettingsChangeStreamRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.themeSettingCreateChangeStreamPostThemeSettingsChangeStreamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async themeSettingDeleteByIdRaw(requestParameters: ThemeSettingDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling themeSettingDeleteById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ThemeSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a model instance by {{id}} from the data source.
     */
    async themeSettingDeleteById(requestParameters: ThemeSettingDeleteByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.themeSettingDeleteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async themeSettingExistsGetThemeSettingsidExistsRaw(requestParameters: ThemeSettingExistsGetThemeSettingsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling themeSettingExistsGetThemeSettingsidExists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ThemeSettings/{id}/exists`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async themeSettingExistsGetThemeSettingsidExists(requestParameters: ThemeSettingExistsGetThemeSettingsidExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.themeSettingExistsGetThemeSettingsidExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async themeSettingExistsHeadThemeSettingsidRaw(requestParameters: ThemeSettingExistsHeadThemeSettingsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingExistsGetRoleMappingsIdExists200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling themeSettingExistsHeadThemeSettingsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ThemeSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'HEAD',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingExistsGetRoleMappingsIdExists200ResponseFromJSON(jsonValue));
    }

    /**
     * Check whether a model instance exists in the data source.
     */
    async themeSettingExistsHeadThemeSettingsid(requestParameters: ThemeSettingExistsHeadThemeSettingsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingExistsGetRoleMappingsIdExists200Response> {
        const response = await this.themeSettingExistsHeadThemeSettingsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async themeSettingFindRaw(requestParameters: ThemeSettingFindRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ThemeSetting>>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ThemeSettings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ThemeSettingFromJSON));
    }

    /**
     * Find all instances of the model matched by filter from the data source.
     */
    async themeSettingFind(requestParameters: ThemeSettingFindRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ThemeSetting>> {
        const response = await this.themeSettingFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async themeSettingFindByIdRaw(requestParameters: ThemeSettingFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling themeSettingFindById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ThemeSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Find a model instance by {{id}} from the data source.
     */
    async themeSettingFindById(requestParameters: ThemeSettingFindByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.themeSettingFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async themeSettingFindOneRaw(requestParameters: ThemeSettingFindOneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ThemeSettings/findOne`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Find first instance of the model matched by filter from the data source.
     */
    async themeSettingFindOne(requestParameters: ThemeSettingFindOneRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.themeSettingFindOneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async themeSettingPatchOrCreateRaw(requestParameters: ThemeSettingPatchOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ThemeSettings`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Patch an existing model instance or insert a new one into the data source.
     */
    async themeSettingPatchOrCreate(requestParameters: ThemeSettingPatchOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.themeSettingPatchOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async themeSettingPrototypePatchAttributesRaw(requestParameters: ThemeSettingPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling themeSettingPrototypePatchAttributes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ThemeSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Patch attributes for a model instance and persist it into the data source.
     */
    async themeSettingPrototypePatchAttributes(requestParameters: ThemeSettingPrototypePatchAttributesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.themeSettingPrototypePatchAttributesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async themeSettingReplaceByIdPostThemeSettingsidReplaceRaw(requestParameters: ThemeSettingReplaceByIdPostThemeSettingsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling themeSettingReplaceByIdPostThemeSettingsidReplace().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ThemeSettings/{id}/replace`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async themeSettingReplaceByIdPostThemeSettingsidReplace(requestParameters: ThemeSettingReplaceByIdPostThemeSettingsidReplaceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.themeSettingReplaceByIdPostThemeSettingsidReplaceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async themeSettingReplaceByIdPutThemeSettingsidRaw(requestParameters: ThemeSettingReplaceByIdPutThemeSettingsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling themeSettingReplaceByIdPutThemeSettingsid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ThemeSettings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Replace attributes for a model instance and persist it into the data source.
     */
    async themeSettingReplaceByIdPutThemeSettingsid(requestParameters: ThemeSettingReplaceByIdPutThemeSettingsidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.themeSettingReplaceByIdPutThemeSettingsidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async themeSettingReplaceOrCreatePostThemeSettingsReplaceOrCreateRaw(requestParameters: ThemeSettingReplaceOrCreatePostThemeSettingsReplaceOrCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ThemeSettings/replaceOrCreate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async themeSettingReplaceOrCreatePostThemeSettingsReplaceOrCreate(requestParameters: ThemeSettingReplaceOrCreatePostThemeSettingsReplaceOrCreateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.themeSettingReplaceOrCreatePostThemeSettingsReplaceOrCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async themeSettingReplaceOrCreatePutThemeSettingsRaw(requestParameters: ThemeSettingReplaceOrCreatePutThemeSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ThemeSettings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Replace an existing model instance or insert a new one into the data source.
     */
    async themeSettingReplaceOrCreatePutThemeSettings(requestParameters: ThemeSettingReplaceOrCreatePutThemeSettingsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.themeSettingReplaceOrCreatePutThemeSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async themeSettingUpdateAllRaw(requestParameters: ThemeSettingUpdateAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleMappingUpdateAll200Response>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ThemeSettings/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleMappingUpdateAll200ResponseFromJSON(jsonValue));
    }

    /**
     * Update instances of the model matched by {{where}} from the data source.
     */
    async themeSettingUpdateAll(requestParameters: ThemeSettingUpdateAllRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleMappingUpdateAll200Response> {
        const response = await this.themeSettingUpdateAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async themeSettingUpsertWithWhereRaw(requestParameters: ThemeSettingUpsertWithWhereRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ThemeSetting>> {
        const queryParameters: any = {};

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/ThemeSettings/upsertWithWhere`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ThemeSettingToJSON(requestParameters['data']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ThemeSettingFromJSON(jsonValue));
    }

    /**
     * Update an existing model instance or insert a new one into the data source based on the where criteria.
     */
    async themeSettingUpsertWithWhere(requestParameters: ThemeSettingUpsertWithWhereRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ThemeSetting> {
        const response = await this.themeSettingUpsertWithWhereRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
